module.exports = __webpack_public_path__ + "static/media/icon-import-lead.23e45417.svg";